import { SizeVariant } from 'src/types';
import { toHexColor } from './colorUtils';

export function getAvatarSize(size: SizeVariant): number {
  switch (size) {
    case 'small':
      return 24;
    case 'large':
      return 48;
    case 'extra-large':
      return 60;
    case 'medium':
    default:
      return 36; // Default size
  }
}

export function getLogoSize(size?: SizeVariant): number {
  switch (size) {
    case 'small':
      return 20;
    case 'large':
      return 100;
    case 'extra-large':
      return 142;
    case 'medium':
    default:
      return 60; // Default size
  }
}

export function getCompanyLogoSize(size: SizeVariant): number {
  switch (size) {
    case 'small':
      return 20;
    case 'large':
      return 48;
    case 'extra-large':
      return 60;
    case 'medium':
    default:
      return 34; // Default size
  }
}

// TODO: MOVE TO COLOR UTILS
export const prependHashToColor = (color: string) => toHexColor({ color });

export function getBackgroundStyle(teamColors: string[]): string {
  return teamColors.length === 1
    ? `linear-gradient(90deg, rgba(0, 0, 0, 0.00) 49.88%, rgba(0, 0, 0, 0.25) 100%), ${prependHashToColor(teamColors[0])}`
    : `linear-gradient(90deg, rgba(0, 0, 0, 0.00) 49.88%, rgba(0, 0, 0, 0.25) 100%), linear-gradient(90deg, ${prependHashToColor(teamColors[0])} 0%, ${prependHashToColor(
        teamColors[1],
      )} 100%)`;
}

const logoVariants = {
  light: 'light',
  dark: 'alt',
};

export function getTeamLogo(teamId: string, variant: keyof typeof logoVariants = 'light'): string {
  if (!Boolean(teamId)) {
    return '';
  }
  // https://sports.cbsimg.net/fly/images/team-logos/alt/21355.svg
  return `https://sports.cbsimg.net/fly/images/team-logos/${logoVariants[variant] ?? logoVariants.light}/${teamId}.svg`;
}

export function getLeagueLogo(leagueId: number | string): string {
  if (!Boolean(leagueId)) {
    return '';
  }
  return `https://sports.cbsimg.net/fly/images/league-logos/${leagueId.toString()}.svg`;
}

export function getPlayerAvatar(playerId: string | number, size: number = 60): string {
  if (!Boolean(playerId)) {
    return '';
  }
  return `https://sportshub.cbsistatic.com/i/sports/player/headshot/${playerId.toString()}.png?width=${size}`;
}
